import React from "react";
import ReactDOM from "react-dom";

import { findCompanyId } from "infrastructure/repository/company-repository";
import { findModels } from "infrastructure/repository/benefit-models-repository";
import { findEmployeesWithFields } from "infrastructure/employees-cache";
import { logError, addContextLog } from "infrastructure/log";
import { translate } from "infrastructure/translate/localization";
import { translateEmployeeProperties } from "infrastructure/translate/translateEmployeeProperties";
import { showErrorMessage } from "usecases/commons/show-error-message";
import EmployeesFilter from "../components/EmployeesFilter";

export function renderFiltersEmployees({
  models,
  taxRegime,
  state,
  payrollCompany,
  costCenter,
  employeesIds,
}) {
  const target = document.getElementById("filters-employees-container");
  const filterConfig = [
    {
      title: translate("employees-section.employee-state"),
      property: "state",
      items: state,
    },
    {
      title: translate("employees-section.tax-regime"),
      property: "taxRegime",
      items: taxRegime,
    },
    {
      title: translate("employees-section.select-model"),
      property: "modelId",
      items: models,
    },
    {
      title: translate("common-messages.business-name"),
      property: "payrollCompany",
      items: payrollCompany,
    },
    {
      title: translate("common-messages.cost-center"),
      property: "costCenter",
      items: costCenter,
    },
  ];

  if (target) {
    ReactDOM.render(
      <EmployeesFilter
        availableFilters={filterConfig}
        employeeIds={employeesIds}
      />,
      target
    );
  }
}

export async function displayEmployeeFilters({ ids } = { ids: null }) {
  try {
    const companyId = await findCompanyId();
    const { data: models } = await findModels();
    const allEmployees = await findEmployeesWithFields({ companyId });
    const currentEmployees = allEmployees.filter(
      (e) => e.state !== "uploading"
    );

    const properties = ["state", "taxRegime", "payrollCompany", "costCenter"];
    const filterChoices = {};

    properties.forEach((property) => {
      filterChoices[property] = [];
    });

    currentEmployees.forEach((employee) => {
      properties.map((propertyName) => {
        const propertyValue = employee[propertyName];
        if (
          propertyValue &&
          !filterChoices[propertyName].some((prop) => prop.id === propertyValue)
        ) {
          filterChoices[propertyName].push({
            id: propertyValue,
            name: translateEmployeeProperties(propertyName, propertyValue),
          });
        }
        return null;
      });
    });

    addContextLog("info", "displayEmployeeFilters", "display-screen", {
      companyId,
    });
    renderFiltersEmployees({ models, ...filterChoices, employeesIds: ids });
  } catch (e) {
    logError(e, "Error to displayEmployeeFilters");
    showErrorMessage(translate("common-messages.basic-error-message"), true, e);
  }
}
